import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance70 = () => {
  let winners = ["534", "345", "524", "439", "318", "327", "219", "276"]
  return <IndividualTable matchType={"16"} gender="F" event="70" subTitle="Puta" data={sampleData2} topRankCount="8" winners={winners} />;
};
export default Distance70;
